import { useState } from "react";

const CCheckbox = (props) => {
  const checkedValues = [];
  let choices = [];
  choices = props.choiceListArray;
  const labelName = props.labelName;
  const spanLabel = props.spanLabel === undefined ? "" : props.spanLabel;
  const name = props.name;
  const isInline = props.isInline === true ? true : false;
  const hidden = props.hidden === true ? true : false;
  const disabled = props.disabled === true ? true : false;
  const labelCustomStyle =
    props.labelCustomStyle === undefined ? {} : props.labelCustomStyle;
  const inputCustomStyle =
    props.inputCustomStyle === undefined ? {} : props.inputCustomStyle;
  const customClassSpanLabel =
    props.customClassSpanLabel === undefined ? "" : props.customClassSpanLabel;
  const customClassLabel =
    props.customClassLabel === undefined ? "" : props.customClassLabel;
  const customClassInput =
    props.customClassInput === undefined ? "" : props.customClassInput;
  const customClassDiv =
    props.customClassDiv === undefined ? "" : props.customClassDiv;
  const customClassInputDiv =
    props.customClassInputDiv === undefined ? "" : props.customClassInputDiv;
  const defaultChecked =
    props.defaultChecked === undefined ? "" : props.defaultChecked;

  const [errorMsg, setErrorMsg] = useState("");
  const [isValid, setIsValid] = useState("");

  const setValue = (choice, value) => {
    if (value.length > 0) {
      if (choice) {
        setIsValid("");
        checkedValues.push(value);
      } else {
        for (let i = 0; i < checkedValues.length; i++) {
          if (checkedValues[i] === value) {
            checkedValues.splice(i, 1);
          }
        }
      }
      props.functionName(name, checkedValues);
    }
  };

  const checkRequired = (choice, value) => {
    if (choice !== undefined) {
      setErrorMsg("");
      setIsValid("");
      setValue(choice, value);
    } else {
      setIsValid("was-validated");
      setErrorMsg("Please choose all");
    }
  };

  return (
    <>
      <div className={`${isValid} ${customClassDiv}`}>
        <div>
          <label
            className={`form-label ${customClassLabel}`}
            style={labelCustomStyle}
          >
            {labelName}
          </label>
          <span className={`${customClassSpanLabel}`}>{spanLabel}</span>
        </div>
        <div
          className={
            isInline === true ? "form-check form-check-inline" : "form-check"
          }
          style={inputCustomStyle}
        >
          {choices.map((item, index) => (
            <div className={customClassInputDiv}>
              <input
                type="checkbox"
                className={`form-check-input ${customClassInput}`}
                value={item.value}
                defaultChecked={
                  defaultChecked.includes(item.value) ? true : false
                }
                id={item.id}
                name={name}
                hidden={hidden}
                required={item.required}
                disabled={disabled}
                onClick={(event) => {
                  item.required === true
                    ? checkRequired(event.target.checked, event.target.value)
                    : setValue(event.target.checked, event.target.value);
                }}
              />

              {item.html === true ? (
                <div
                  className="form-check-label"
                  dangerouslySetInnerHTML={{ __html: item.label }}
                />
              ) : (
                <label className="form-check-label">{item.label}</label>
              )}

              {index === choices.length - 1 ? (
                <div className="invalid-feedback">{errorMsg}</div>
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CCheckbox;
